module.exports = __webpack_public_path__ + "img/jl-banner_1.2b29a786.png";